export default __webpack_public_path__ + "static/media/M-M-Cake.6ce3a50f.jpg";